import React, { useEffect, useState, useContext } from 'react';
import { Box, Paper, Typography, CircularProgress, Alert, Stack, Button } from '@mui/material';
import { API_URL } from '../utils/apiConfig';
import { AuthContext } from '../context/AuthContext';
import SchemaRenderer from './forms/SchemaRenderer';

export default function FormsVNext() {
  const { isAuthenticated } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [templates, setTemplates] = useState([]);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        setLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const resp = await fetch(`${API_URL.replace(/\/$/, '')}/vnext/forms/templates`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await resp.json();
        if (!resp.ok) throw new Error(data.error || 'Failed to load templates');
        setTemplates(data.data || []);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  if (!isAuthenticated) return null;
  if (loading) return <Box display="flex" justifyContent="center" mt={4}><CircularProgress/></Box>;
  if (error) return <Alert severity="error" sx={{ mt:2 }}>{error}</Alert>;

  const tmpl = templates[0];
  const schema = tmpl?.json_schema || null;

  return (
    <Paper sx={{ p:2 }}>
      <Typography variant="h6" sx={{ mb:2 }}>Forms vNext (Scaffold)</Typography>
      {!tmpl ? (
        <Typography color="text.secondary">No templates available.</Typography>
      ) : (
        <>
          <Typography variant="subtitle1" sx={{ mb:1 }}>{tmpl.name} v{tmpl.version}</Typography>
          <SchemaRenderer schema={schema} value={formData} onChange={setFormData} />
          <Stack direction="row" spacing={1} sx={{ mt:2 }}>
            <Button variant="contained" disabled>Submit (stub)</Button>
            <Button variant="text" onClick={() => setFormData({})}>Reset</Button>
          </Stack>
        </>
      )}
    </Paper>
  );
}

